import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-4 grid md:grid-cols-2 gap-4 mb-5" }
const _hoisted_2 = { class: "mb-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, "Primary Buttons", -1)
const _hoisted_4 = { class: "flex items-center gap-4 mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-upload" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-upload" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-upload" }, null, -1)
const _hoisted_8 = { class: "flex items-center gap-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-upload" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-upload" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-upload" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, "Upload Button", -1)
const _hoisted_13 = { class: "flex items-center gap-4 mb-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-upload" }, null, -1)
const _hoisted_15 = { class: "flex items-center gap-4" }
const _hoisted_16 = { class: "p-4 grid md:grid-cols-2 gap4 mb-5" }
const _hoisted_17 = { class: "mb-5" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, "Secondary Buttons", -1)
const _hoisted_19 = { class: "flex items-center gap-4 mb-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-upload" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-upload" }, null, -1)
const _hoisted_22 = { class: "flex items-center gap-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-upload" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-upload" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-upload" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, "Upload Button", -1)
const _hoisted_27 = { class: "flex items-center gap-4 mb-3" }
const _hoisted_28 = { class: "flex items-center gap-4" }
const _hoisted_29 = { class: "p-4 grid md:grid-cols-2 gap-4 mb-5" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", null, "Search box", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", null, "Date Filter", -1)
const _hoisted_32 = { class: "p-4 grid md:grid-cols-2 gap-4 mb-5" }
const _hoisted_33 = { class: "p-4 grid md:grid-cols-2 gap-4 mb-5" }
const _hoisted_34 = { class: "border-bottom-grey-300" }
const _hoisted_35 = { class: "md:flex items-center md:justify-between mb-1" }
const _hoisted_36 = { class: "font-bold" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "rounded-3xl border-primary background-primary-700 px-3 py-2 text-white font-bold text-base" }, /*#__PURE__*/_toDisplayString('Berangkat'), -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "mb-1" }, /*#__PURE__*/_toDisplayString('12 Maret 2024'), -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "rounded-3xl border-danger-500 background-danger-700 px-4 py-2 text-white font-bold text-xs w-fit" }, /*#__PURE__*/_toDisplayString('Belum Lunas'))
], -1)
const _hoisted_40 = { class: "mb-2 flex justify-between items-end" }
const _hoisted_41 = { class: "" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl font-normal" }, /*#__PURE__*/_toDisplayString('Total Harga'), -1)
const _hoisted_43 = { class: "text-3xl font-bold" }
const _hoisted_44 = { class: "" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-5xl text-right" }, /*#__PURE__*/_toDisplayString('AA'), -1)
const _hoisted_46 = { class: "text-xl font-normal text-right" }
const _hoisted_47 = { class: "flex items-center justify-between pt-3" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-1" }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "text-primary pi pi-circle-fill",
      style: {"font-size":"16px"}
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "text-xl font-bold" }, [
      /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('3') + " "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-normal" }, /*#__PURE__*/_toDisplayString('Kg'))
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-1" }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "text-primary pi pi-circle-fill",
      style: {"font-size":"16px"}
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "text-xl font-bold" }, [
      /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('2') + " "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-normal" }, /*#__PURE__*/_toDisplayString('Koli'))
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-1" }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "text-primary pi pi-circle-fill",
      style: {"font-size":"16px"}
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "text-xl font-bold" }, [
      /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('28') + " "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-normal" }, [
        /*#__PURE__*/_createTextVNode("m"),
        /*#__PURE__*/_createElementVNode("sup", null, "3")
      ])
    ])
  ])
], -1)

import {
  ref,
  toRefs,
  getCurrentInstance,
  defineComponent
} from 'vue'
import Button from 'primevue/button'
import ButtonFileUpload from '@/views/components/button/FileUpload.vue'
import ButtonPrimary from '@/views/components/button/ButtonPrimary.vue'
import ButtonUploadPrimary from '@/views/components/button/ButtonPrimaryUpload.vue'
import ButtonSecondary from '@/views/components/button/ButtonSecondary.vue'
import ButtonUploadSecondary from '@/views/components/button/ButtonSecondaryUpload.vue'
import SearchBox from '@/views/components/form/SearchBox.vue'
import DateFilterBox from '@/views/components/form/DateFilterBox.vue'
import SortBox from '@/views/components/form/SortBox.vue'
import CardBlueBorder from '@/views/components/card/CustomBlueBorder.vue'
import StatusFilterBox from '@/views/components/form/StatusFilterBox.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'components',
  setup(__props) {

const app = getCurrentInstance()
const {
  $icon
} = app!.appContext.config.globalProperties
const maxSizeFile = 1024 * 1024 * 1
const inputSearch = ref('')
const icon = $icon

const onSearch = (val: any) => console.log('search~', inputSearch.value)

const onSubmitFilterDate = (val: any) => console.log('submitFilterDate', val)

const onSubmitSort = (val: any) => console.log('submitSort', val)

const onSubmitFilterStatus = (val: any) => console.log('submitFilterStatus', val)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(ButtonPrimary, {
            classList: 'btn-size-lg',
            buttonText: 'Button name'
          }, {
            icon: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(ButtonPrimary, {
            classList: 'btn-size-md',
            buttonText: 'Button name'
          }, {
            icon: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(ButtonPrimary, {
            classList: 'btn-size-sm',
            buttonText: 'Button name'
          }, {
            icon: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(ButtonPrimary, {
            classList: 'btn-size-lg',
            buttonText: 'Button name',
            isDisabled: true
          }, {
            icon: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(ButtonPrimary, {
            classList: 'btn-size-md',
            buttonText: 'Button name',
            isDisabled: true
          }, {
            icon: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(ButtonPrimary, {
            classList: 'btn-size-sm',
            buttonText: 'Button name',
            isDisabled: true
          }, {
            icon: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createVNode(ButtonUploadPrimary, {
            buttonClassList: 'btn-size-lg',
            buttonText: 'Upload'
          }, {
            icon: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }),
          _createVNode(ButtonUploadPrimary, {
            buttonClassList: 'btn-size-md',
            buttonText: 'Upload'
          }),
          _createVNode(ButtonUploadPrimary, {
            buttonClassList: 'btn-size-sm',
            buttonText: 'Upload'
          })
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(ButtonUploadPrimary, {
            buttonClassList: 'btn-size-lg',
            buttonText: 'Upload',
            isDisabled: true
          }),
          _createVNode(ButtonUploadPrimary, {
            buttonClassList: 'btn-size-md',
            buttonText: 'Upload',
            isDisabled: true
          }),
          _createVNode(ButtonUploadPrimary, {
            buttonClassList: 'btn-size-sm',
            buttonText: 'Upload',
            isDisabled: true
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createVNode(ButtonSecondary, {
            classList: 'btn-size-lg',
            buttonText: 'Button name'
          }),
          _createVNode(ButtonSecondary, {
            classList: 'btn-size-md',
            buttonText: 'Button name'
          }, {
            icon: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          }),
          _createVNode(ButtonSecondary, {
            classList: 'btn-size-sm',
            buttonText: 'Button name'
          }, {
            icon: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(ButtonSecondary, {
            classList: 'btn-size-lg',
            buttonText: 'Button name',
            isDisabled: true
          }, {
            icon: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          }),
          _createVNode(ButtonSecondary, {
            classList: 'btn-size-md',
            buttonText: 'Button name',
            isDisabled: true
          }, {
            icon: _withCtx(() => [
              _hoisted_24
            ]),
            _: 1
          }),
          _createVNode(ButtonSecondary, {
            classList: 'btn-size-sm',
            buttonText: 'Button name',
            isDisabled: true
          }, {
            icon: _withCtx(() => [
              _hoisted_25
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_26,
        _createElementVNode("div", _hoisted_27, [
          _createVNode(ButtonUploadSecondary, {
            buttonClassList: 'btn-size-lg',
            buttonText: 'Upload'
          }),
          _createVNode(ButtonUploadSecondary, {
            buttonClassList: 'btn-size-md',
            buttonText: 'Upload'
          }),
          _createVNode(ButtonUploadSecondary, {
            buttonClassList: 'btn-size-sm',
            buttonText: 'Upload'
          })
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(ButtonUploadSecondary, {
            buttonClassList: 'btn-size-lg',
            buttonText: 'Upload',
            isDisabled: true
          }),
          _createVNode(ButtonUploadSecondary, {
            buttonClassList: 'btn-size-md',
            buttonText: 'Upload',
            isDisabled: true
          }),
          _createVNode(ButtonUploadSecondary, {
            buttonClassList: 'btn-size-sm',
            buttonText: 'Upload',
            isDisabled: true
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", null, [
        _hoisted_30,
        _createVNode(SearchBox, {
          placeholder: 'Search...',
          modelValue: inputSearch.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputSearch).value = $event)),
          canClick: true,
          icon: _unref(icon).svg.searchEva,
          onSubmitInput: onSearch,
          onKeyup: _withKeys(onSearch, ["enter"])
        }, null, 8, ["placeholder", "modelValue", "icon", "onKeyup"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_31,
        _createVNode(DateFilterBox, { onClick: onSubmitFilterDate })
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", null, [
        _createVNode(SortBox, { onClick: onSubmitSort })
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createVNode(CardBlueBorder, null, {
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("h3", _hoisted_36, _toDisplayString('MIISI.PAKET.TA.23.10.0000145'), 1),
              _hoisted_37
            ]),
            _hoisted_38,
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _createElementVNode("div", _hoisted_43, _toDisplayString('Rp. 120.000'), 1)
              ]),
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("div", _hoisted_46, _toDisplayString('P.Blitar - Paket T.A'), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _createElementVNode("div", null, [
              _createVNode(ButtonPrimary, {
                classList: 'btn-size-lg',
                buttonText: 'Lihat Detail',
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDetail(0)))
              })
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(StatusFilterBox, { onClick: onSubmitFilterStatus })
    ])
  ], 64))
}
}

})